import { NgModule } from '@angular/core';
import { DesignSystemComponent } from './design-system.component';
import { WindowService } from './shared/services/window.service';

@NgModule({
  declarations: [DesignSystemComponent],
  imports: [],
  exports: [DesignSystemComponent],
  providers: [WindowService],
})
export class DesignSystemModule {}
